import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearAwayNotice, tournamentStarted } from '../redux/gameSlice';
import './KickedNotice.css';

// Global popup shown after this player "leaves" a LIVE tournament / Sit-and-Go table.
//
// Tournament chips are table-instance currency, so leaving does not leave: the seat, its stack
// and its blind obligations all stay, and the player is simply parked AWAY (still dealt in,
// still posting blinds, auto check-folding) until they rejoin or bust. The table VIEW was torn
// down on the button press, so without this there would be no in-session route back — the
// /games/myseats self-heal only runs on the next socket connect.
//
// "Return to table" dispatches the same tournamentStarted action the self-heal uses, so the
// re-open goes through exactly one code path (subscribe + snapshot in socketMiddleware).
// Reuses the kicked-notice styling; rendered at the app level so it survives the teardown.
const AwayTableNotice = () => {
    const dispatch = useDispatch();
    const notice = useSelector((state) => state.games.awayNotice);

    if (!notice) return null;

    const handleReturn = () => {
        dispatch(tournamentStarted({
            roomId: notice.roomId,
            seatNumber: notice.seatNumber,
            tableName: notice.tableName,
        }));
        dispatch(clearAwayNotice());
    };

    return (
        <div className="kicked-notice-overlay" onClick={() => dispatch(clearAwayNotice())}>
            <div className="kicked-notice-box" onClick={(e) => e.stopPropagation()}>
                <span className="kicked-notice-title">You are away, not out</span>
                <span className="kicked-notice-subtext">
                    {notice.tableName
                        ? `${notice.tableName} — your seat, chips and blinds are still in play.`
                        : 'Your seat, chips and blinds are still in play.'}
                    {' '}You are auto check-folding until you return or run out of chips.
                </span>
                <button className="kicked-notice-btn" onClick={handleReturn}>
                    Return to table
                </button>
                <button className="kicked-notice-btn" onClick={() => dispatch(clearAwayNotice())}>
                    Stay away
                </button>
            </div>
        </div>
    );
};

export default AwayTableNotice;
